import {CSSProperties, FC} from 'react';


export interface IIconOilThermometerProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconOilThermometer: FC<IIconOilThermometerProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <g clipPath="url(#a)"><path d="M18.95 5.032h-2.231A2.435 2.435 0 0 0 14.283 3c-1.334.02-2.394 1.132-2.394 2.466v9.052a.576.576 0 0 1-.16.4 3.568 3.568 0 0 0-1 2.541A3.605 3.605 0 0 0 14.37 21c3.147-.043 4.7-3.84 2.543-6.08a.578.578 0 0 1-.162-.4v-1.067h.746c.313 0 .581-.24.596-.553a.58.58 0 0 0-.58-.609h-.762V9.823h1.472c.312 0 .581-.24.596-.553a.58.58 0 0 0-.58-.609h-1.488V6.194h2.214a.58.58 0 0 0 .58-.609.591.591 0 0 0-.597-.553Zm-4.726 13.715c-1.22-.087-1.705-1.656-.715-2.409a.582.582 0 0 0 .23-.463V8.932c0-.313.241-.582.554-.597a.58.58 0 0 1 .608.58v6.953c0 .182.082.357.227.467 1.066.805.425 2.505-.904 2.412ZM4.05 6.194c-.88 0-1.596-.717-1.596-1.597S3.17 3 4.05 3c.88 0 1.597.716 1.597 1.597 0 .88-.716 1.597-1.597 1.597Zm0-2.033a.436.436 0 1 0 .001.872.436.436 0 0 0 0-.872Zm4.047 6.896A2.489 2.489 0 0 1 5.61 8.57V6.865a2.489 2.489 0 0 1 2.486-2.486c.744 0 1.443.33 1.918.904a.58.58 0 0 1-.896.74c-.787-.955-2.347-.398-2.347.842V8.57c0 1.24 1.56 1.795 2.347.842a.58.58 0 1 1 .896.739 2.479 2.479 0 0 1-1.918.905Z" /></g>
            <defs><clipPath id="a"><path d="M0 0H18V18H0z" transform="translate(2 3)" /></clipPath></defs>
        </svg>
    );
};
